import type { SelectChangeEvent } from '@mui/material';
import { useMemo } from 'react';

import type { TableSelectorProps, UseTableSelectorResult } from '../types';

export const useTableSelector = ({
  options,
  selectedId,
  onChange,
}: TableSelectorProps): UseTableSelectorResult => {
  const selectedIndex = useMemo(
    () => options.findIndex((option) => option.id === selectedId),
    [options, selectedId]
  );

  const onSelectChange = (event: SelectChangeEvent) => onChange(event.target.value);

  return { selectedIndex, onSelectChange };
};
